import React, {useContext, useEffect, useState} from 'react';
import {Modal, ScrollView, View} from 'react-native';
import MainStyle from '../../../../../MainStyle';
import {colors} from '../../../../assets/styles/colors';
import Button from '../../../../components/Button';
import Div from '../../../../lib/Div';
import P from '../../../../lib/P';
import {ListTournamentRequest_Sort, ListTournamentRequest_TournamentAccess, TournamentState} from '../../../../../generated/smg_service_pb';
import ServiceClient from '../../../../utils/ServiceClient';
import {StoreContext} from '../../../../components/StoreContextProvider';
import Input from "../../../../components/Input";
import {formatPayout} from "../../../../utils";
import {isFullSwing} from "../../../../constants";

type Props = {
  isOpen: boolean, onClose: () => void, onConfirm: () => void, totalShots: number, maxParticipants: number,
  entryFee: number
};

const FriendsChallengeConfirmation = (props: Props) => {
  const {isOpen, totalShots, maxParticipants, entryFee} = props;
  const Context = useContext(StoreContext);
  const [completedPrivateTournaments, setCompletedPrivateTournaments] = useState(0);

  const getCompletedPrivateTournaments = () => {
    Context.setLoadingOverlay(true);
    const states = [TournamentState.FINISHED, TournamentState.CANCELLED, TournamentState.VOIDED];

    ServiceClient.listTournaments(states, ListTournamentRequest_Sort.FINISH_TIME, [ListTournamentRequest_TournamentAccess.FRIENDS], true).then(res => {
      setCompletedPrivateTournaments(res.length);

    }).catch(err => {
      console.log('listTournaments err', err);

    }).finally(() => {
      Context.setLoadingOverlay(false);
    });
  };

  useEffect(() => {
    if (isOpen) getCompletedPrivateTournaments();
  }, [isOpen]);

  return (
    <Modal animationType="fade" transparent visible={isOpen} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={props.onClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={[MainStyle.flex1, MainStyle.p_x_20]}>
          <Div minH="100%" alignItems="center" justifyContent="center">
            <Div maxW={390} w="100%" rounded={20} borderWidth={1} borderColor={colors.settings_border}
                 bg={isFullSwing ? '#131314' : colors.settings_bg} pt={isFullSwing ? 0 : 30} alignItems="center"
                 overflow="hidden">
              <P fw="500" fs={isFullSwing ? 20 : 26} lh={isFullSwing ? 48 : 26} mb={isFullSwing ? 40 : 24} w="100%"
                 ta="center" bg={isFullSwing ? '#252526' : undefined}>
                Friends Challenge Confirmation
              </P>

              <Input
                label="NUMBER OF PLAYERS" value={`${maxParticipants}`} bg="transparent" mb={9} w={240} h={48}
                textAlign="center" editable={false} rounded={isFullSwing ? 4 : undefined}
              />

              <Input
                label="SHOTS" value={`${totalShots}`} bg="transparent" mb={9} w={240} h={48} textAlign="center"
                editable={false} rounded={isFullSwing ? 4 : undefined}
              />

              <Input
                label="PRIZE POOL" bg="transparent" mb={9} w={240} h={48} textAlign="center" editable={false}
                value={formatPayout(maxParticipants * entryFee * (completedPrivateTournaments < 3 ? 1 : 0.9))}
                rounded={isFullSwing ? 4 : undefined}
              />

              <Input
                label="ENTRY FEE" value={formatPayout(entryFee)} bg="transparent" mb={21} w={240} h={48}
                textAlign="center" editable={false} rounded={isFullSwing ? 4 : undefined}
              />

              <Button
                onPress={props.onConfirm} text="CONFIRM AND START" w={309} fontWeight="600" mb={10}
                bg={isFullSwing ? '#3369FF' : undefined} radius={isFullSwing ? 4 : undefined}
                color={isFullSwing ? 'white' : undefined}
              />

              <Button
                text="Back" w={309} bg={isFullSwing ? '#252526' : colors.loading_login} borderWidth={1}
                borderColor={isFullSwing ? '#4C4C4C' : 'white'} onPress={props.onClose} color="white"
                radius={isFullSwing ? 4 : undefined}
              />

              <P color={isFullSwing ? 'white' : colors.gray} ta="center" fs={17} mt={20} px={15} mb={33}>
                Challenge is voided if the total number of players who enter the tournament is not met.
              </P>
            </Div>
          </Div>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default React.memo(FriendsChallengeConfirmation);
